webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getInertia;
function getInertia(destinationValue, value, inertia) {
  var valueToAdd = Math.abs((destinationValue - value) * inertia) >= 0.01 ? (destinationValue - value) * inertia : destinationValue - value;
  value += valueToAdd;

  return value;
}

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lazyloadImage = function lazyloadImage(el) {
  el.dataset.lazyload = "loading";

  var observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var image = entry.target;

        var onLoad = function onLoad() {
          image.dataset.lazyload = "loaded";
          image.removeEventListener("load", onLoad);
        };

        image.addEventListener("load", onLoad);

        image.src = image.dataset.src;

        if (image.dataset.srcset) {
          image.srcset = image.dataset.srcset;
        }

        observer.unobserve(image);
      }
    });
  });

  observer.observe(el);
};

var lazyloadVideo = function lazyloadVideo(el, callback) {
  var observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      var video = entry.target;

      if (entry.isIntersecting) {
        for (var source in video.children) {
          var videoSource = video.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src;
          }
        }
        var onLoad = function onLoad() {
          if (callback) {
            callback();
          }

          video.removeEventListener("canplaythrough", onLoad);
        };

        video.addEventListener("canplaythrough", onLoad);
        video.load();

        observer.unobserve(video);
      }
    });
  });

  observer.observe(el);
};

function bind(el, _ref, vnode) {
  var _ref$value = _ref.value,
      value = _ref$value === undefined ? {} : _ref$value;
  var callback = value.callback;


  vnode.context.$nextTick(function () {
    if (el.tagName === "VIDEO") {
      lazyloadVideo(el, callback);
    } else {
      lazyloadImage(el);
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: bind
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_HomeView__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_HomeView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_HomeView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_AboutView__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_AboutView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_AboutView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ContactView__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ContactView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_ContactView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ProjectListView__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_ProjectListView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_ProjectListView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ProjectView__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ProjectView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_ProjectView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_NotFound__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_HomeView___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_3__views_AboutView___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_4__views_ContactView___default.a
  }, {
    path: '/project',
    name: 'ProjectList',
    component: __WEBPACK_IMPORTED_MODULE_5__views_ProjectListView___default.a
  }, {
    path: '/project/:slug',
    name: 'Project',
    component: __WEBPACK_IMPORTED_MODULE_6__views_ProjectView___default.a
  }, {
    path: '*',
    name: 'NotFound',
    component: __WEBPACK_IMPORTED_MODULE_7__views_NotFound___default.a
  }]
}));

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(94);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    email: null,
    content: {
      about: null
    },
    projects: []
  },
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  strict: debug
}));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(146)
  __webpack_require__(147)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b82f98b8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intersection_observer__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intersection_observer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preload_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_preload_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_preload_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppHeader__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shapes__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shapes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Shapes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_UMath__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_EventBus_js__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_5__components_AppHeader___default.a,
    Shapes: __WEBPACK_IMPORTED_MODULE_6__components_Shapes___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_7__components_Loader___default.a
  },

  data: function data() {
    return {
      SCROLL_INERTIA: 0.07,
      MOUSE_INERTIA: 0.05,
      TILT_INERTIA: 0.04,
      observerRatio: 0.5,

      isLoading: null,
      loaderProgress: 0,
      isLoaded: false,
      isLoaderShow: false,

      $body: null,
      $mainWrapper: null,
      $window: null,

      appear: true,

      // mouse position
      m: {
        x: null,
        y: null
      },

      // mouse position with inertia
      mI: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      },

      loadingStyle: {
        // here i use visibility to avoid overwrite opacity used for animation of different component
        visibility: "hidden"
      },

      sY: null, // scroll Y
      siY: null, // scroll inertia Y

      previousRoute: null,
      observerInitialized: false,

      isDesktop: window.innerWidth > 1024,
      isShapesVisible: null
    };
  },


  computed: {
    numberOfShapes: function numberOfShapes() {
      return this.isDesktop ? 23 : 8;
    }
  },

  created: function created() {
    this.queue = new __WEBPACK_IMPORTED_MODULE_3_preload_js___default.a.LoadQueue(true, null, true);
    this.queue.on("complete", this.onImageLoaded, this);
    this.$store.dispatch("FETCH_EMAIL");
    this.$store.dispatch("FETCH_ABOUT_CONTENT");
  },
  mounted: function mounted() {
    var _this = this;

    var name = this.$route.name;

    this.previousRoute = name;

    this.$body = document.querySelector("body");
    this.$mainWrapper = document.querySelector("#mainWrapper");
    this.$window = window;

    this.m = {
      x: window.innerWidth / 2,
      y: window.innerHeight / 2
    };

    this.bindEvents();
    this.onResize();

    __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].to(this, 0.8, {
      loaderProgress: 80,
      delay: 0.2,
      ease: Expo.easeOut
    });
    this.isLoading = true;
    this.$store.dispatch("FETCH_PROJECTS").then(function () {
      _this.queue.loadManifest(_this.getAssetsToLoad());
    });

    // fake appear animation
    __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].set(this.$refs.main, { autoAlpha: 0 });

    this.$refs.loader.$once("before-hide", function () {
      __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].fromTo(_this.$refs.main, 0.8, {
        autoAlpha: 0,
        y: -40
      }, {
        y: 0,
        autoAlpha: 1,
        delay: 0.3,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: function onComplete() {
          _this.setBodyHeight();
        }
      });
    });
  },


  methods: {
    enter: function enter(el, done) {
      this.resetScroll();

      this.$refs.page.enter ? this.$refs.page.enter(done) : __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].from(el, 0.5, {
        autoAlpha: 0,
        ease: Quad.easeOut,
        force3D: true,
        onComplete: done
      });

      this.setBodyHeight();
      this.verifyShapesVisibility();
    },
    leave: function leave(el, done) {
      this.$refs.page.leave ? this.$refs.page.leave(done) : __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].to(el, 0.35, {
        autoAlpha: 0,
        ease: Quad.easeOut,
        force3D: true,
        onComplete: done
      });
    },
    bindEvents: function bindEvents() {
      TweenLite.ticker.addEventListener("tick", this.rAF.bind(this));

      window.addEventListener("resize", this.onResize.bind(this));

      if (this.isDesktop) {
        window.addEventListener("mousemove", this.updateMousePos.bind(this));
      }
    },
    updateMousePos: function updateMousePos(e) {
      this.m = {
        x: e.clientX,
        y: e.clientY
      };
    },
    rAF: function rAF() {
      this.setRafProps();
      __WEBPACK_IMPORTED_MODULE_9__util_EventBus_js__["a" /* default */].$emit("rAF");
    },
    setRafProps: function setRafProps() {
      this.sY = this.$window.scrollY || this.$window.pageYOffset;
      this.siY = __WEBPACK_IMPORTED_MODULE_8__util_UMath__["a" /* getInertia */](this.sY, this.siY, this.SCROLL_INERTIA);

      if (this.isDesktop) {
        this.mI = {
          x: __WEBPACK_IMPORTED_MODULE_8__util_UMath__["a" /* getInertia */](this.m.x, this.mI.x, this.MOUSE_INERTIA),
          y: __WEBPACK_IMPORTED_MODULE_8__util_UMath__["a" /* getInertia */](this.m.y, this.mI.y, this.MOUSE_INERTIA)
        };
      }
    },
    onResize: function onResize() {
      this.setBodyHeight();
      this.resetScroll();

      this.isDesktop = window.innerWidth > 1024;
    },
    initObserver: function initObserver() {
      var $sections = document.querySelectorAll(".js-observer");

      var options = {
        threshold: this.observerRatio
      };

      this.observer = new IntersectionObserver(this.onIntersection.bind(this), options);

      var $section;

      for (var i = 0; i < $sections.length; i++) {
        $section = $sections[i];
        this.observer.observe($section);
      }
    },
    onIntersection: function onIntersection(entries) {
      var entry;
      var $target;

      for (var e = 0; e < entries.length; e++) {
        entry = entries[e];

        if (entry.intersectionRatio > this.observerRatio) {
          $target = entry.target;
          $target.classList.add("is-visible");
          this.observer.unobserve(entry.target);
        }
      }
    },
    setBodyHeight: function setBodyHeight() {
      if (this.isDesktop) {
        __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].set(this.$body, { height: this.$mainWrapper.offsetHeight });
      }
    },
    scrollContent: function scrollContent() {
      if (this.isDesktop) {
        __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].set(this.$mainWrapper, { y: -this.siY, force3D: true });
      }
    },
    resetScroll: function resetScroll() {
      this.sY = this.siY = 0;
      __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].set(this.$mainWrapper, { y: 0, force3D: true });
    },
    verifyShapesVisibility: function verifyShapesVisibility() {
      if (["NotFound", "Project", "Home"].includes(this.$route.name)) {
        this.isShapesVisible = false;
        return;
      }

      if (this.isDesktop) {
        this.isShapesVisible = true;
      } else {
        this.isShapesVisible = this.$route.name === "Home";
      }
    },
    getAssetsToLoad: function getAssetsToLoad() {
      var manifest = [];

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.$store.state.projects).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            project = _ref2[1];

        manifest.push({
          src: project.better_featured_image.media_details.source_url,
          id: "project-" + key + "-thumbnail"
        });
      });

      return manifest;
    },
    onImageLoaded: function onImageLoaded() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].to(this, 0.4, {
        loaderProgress: 100,
        ease: Quart.easeOut
      });

      __WEBPACK_IMPORTED_MODULE_4_gsap__["a" /* TweenMax */].delayedCall(0.4, function () {
        _this2.isLoading = false;

        // set visible if page is not prerendered
        _this2.loadingStyle = {
          visibility: "visible"
        };
      });
    },
    onLoaderShown: function onLoaderShown() {
      this.isLoaderShow = true;
    },
    onLoaderHidden: function onLoaderHidden() {
      this.isLoaded = true;
      this.verifyShapesVisibility();
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isOpen: false
    };
  },

  watch: {
    $route: function $route() {
      // make sure that mobile menu is closed on route change
      this.isOpen = false;
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: undefined
    },
    size: {
      type: String,
      default: "aspect-ratio",
      validator: function validator(value) {
        return ["aspect-ratio", "cover"].includes(value);
      }
    },
    width: {
      type: Number,
      default: 960
    },
    height: {
      type: Number,
      default: 540
    },
    alt: {
      type: String,
      default: undefined
    }
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseImage_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseImage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BaseImage_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    BaseImage: __WEBPACK_IMPORTED_MODULE_0__components_BaseImage_vue___default.a
  },
  props: {
    src: {
      type: String,
      required: true
    },
    placeholderSrc: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isLoaded: false
    };
  },

  methods: {
    onLoaded: function onLoaded() {
      this.isLoaded = true;
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cms-content',
  props: {
    content: String
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "loader",
  props: {
    percentage: Number,
    isVisible: Boolean
  },

  data: function data() {
    return {
      tl: {},
      $percentage: null
    };
  },


  watch: {
    isVisible: function isVisible(_isVisible) {
      if (this.isVisible) {
        this.show();
      } else {
        this.hide();
      }
    }
  },

  computed: {
    formatedPercentage: function formatedPercentage() {
      return parseInt(this.percentage);
    }
  },

  mounted: function mounted() {
    this.$percentage = this.$el.querySelector(".percentage");
  },


  methods: {
    show: function show() {
      this.tl.show = new TimelineMax({
        onComplete: this.onShowComplete,
        onCompleteScope: this,
        delay: 0.2
      }).from(this.$el, 0.8, { y: "-100%", ease: Quart.easeOut }, 0).from(this.$percentage, 0.8, { y: this.$el.offsetHeight, ease: Quart.easeOut }, 0);
    },
    hide: function hide() {
      if (this.isVisible) {
        return;
      }

      this.$emit("before-hide");

      this.tl.hide = new TimelineMax({
        onComplete: this.onHideComplete,
        onCompleteScope: this,
        delay: 0.2
      }).to(this.$el, 0.8, { y: "100%", ease: Quart.easeOut }, 0).to(this.$percentage, 0.8, { y: -this.$el.offsetHeight, ease: Quart.easeOut }, 0);
    },
    onHideComplete: function onHideComplete() {
      this.$emit("hidden");
      TweenMax.set(this.$el, { display: "none" });
    },
    onShowComplete: function onShowComplete() {
      this.$emit("shown");
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shapes',
  props: {
    mouse: Object,
    number: Number,
    isDekstop: Boolean,
    isVisible: Boolean,
    tilt: Object
  },
  data: function data() {
    return {
      $firstLayer: null,
      $secondLayer: null,
      w: 0,
      h: 0,
      centerX: 0,
      centerY: 0
    };
  },


  watch: {
    mouse: function mouse(_mouse) {
      this.updateLayers();
    },
    tilt: function tilt(_tilt) {
      this.updateLayers();
    }
  },

  mounted: function mounted() {
    this.$firstLayer = this.$el.querySelector('.js-first-layer');
    this.$secondLayer = this.$el.querySelector('.js-second-layer');
    this.w = this.$el.offsetWidth;
    this.h = this.$el.offsetHeight;
    this.centerX = window.innerWidth / 2;
    this.centerY = window.innerHeight / 2;

    var shape = void 0;
    var shapeInner = void 0;
    var shapeX = void 0;
    var shapeY = void 0;
    var offsetY = void 0;
    var shapeClass = void 0;

    offsetY = this.isDekstop ? 150 : 85;

    var rotation = [0, 45, 90, 135];
    var bgColor = ['#F0F2F2', '#E54B4B', '#38489D'];
    var scale = [0.5, 0.75, 1];
    var shapes = ['stick', 'stick', 'stick', 'circle', 'circle', 'circle', 'empty-circle', 'empty-circle', 'crop-circle', 'half-circle', 'half-circle'];

    // generate shapes
    for (var i = 0; i < this.number; i++) {
      shape = document.createElement('div');
      shapeInner = document.createElement('div');
      shapeInner.classList.add('shape-inner');
      shape.classList.add('shape');
      shapeX = Math.floor(Math.random() * this.w) - 40;
      shapeY = Math.floor(Math.random() * (this.h - offsetY - offsetY)) + offsetY;

      shapeClass = shapes[Math.floor(Math.random() * shapes.length)];
      shape.classList.add('shape--' + shapeClass);

      var shapeColor = bgColor[Math.floor(Math.random() * bgColor.length)];

      TweenMax.set(shape, {
        x: shapeX,
        y: shapeY,
        rotation: rotation[Math.floor(Math.random() * rotation.length)],
        backgroundColor: shapeColor,
        scale: scale[Math.floor(Math.random() * scale.length)]
      });

      if (shapeClass === 'empty-circle') {
        TweenMax.set(shape, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
      } else if (shapeClass === 'crop-circle') {
        TweenMax.set(shape, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
        TweenMax.set(shapeInner, {
          backgroundColor: 'transparent',
          borderColor: shapeColor
        });
      }

      if (i % 2 === 0) {
        this.$firstLayer.appendChild(shape);
      } else {
        this.$secondLayer.appendChild(shape);
      }

      shape.appendChild(shapeInner);
    }
  },


  methods: {
    updateLayers: function updateLayers() {
      var x = void 0;
      var y = void 0;

      if (this.isDekstop) {
        x = this.mouse.x;
        y = this.mouse.y;
      } else {
        x = this.tilt.x * 17.5;
        y = this.tilt.y * 17.5;
      }

      if (x === 0 && y === 0) {
        return;
      }

      var sensibility = 0.095;
      var parallaxDepth = 1.9;

      var dX = void 0;
      var dY = void 0;
      var offsetX = void 0;
      var offsetY = void 0;

      dX = x - this.centerX;
      dY = y - this.centerY;

      offsetX = dX * sensibility;
      offsetY = dY * sensibility;

      TweenMax.set(this.$firstLayer, {
        x: offsetX,
        y: offsetY,
        force3D: true
      });

      TweenMax.set(this.$secondLayer, {
        x: offsetX / parallaxDepth,
        y: offsetY / parallaxDepth,
        force3D: true
      });
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CMSContent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CMSContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CMSContent__);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about-view',
  components: {
    CmsContent: __WEBPACK_IMPORTED_MODULE_1__components_CMSContent___default.a
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    content: function content(state) {
      return state.content.about;
    }
  }),

  methods: {
    enter: function enter(done) {
      var tl = new TimelineMax({
        onComplete: done
      });

      var $pageTitle = this.$el.querySelector('.js-page-title');
      var $content = this.$el.querySelector('.js-content');

      tl.set($pageTitle, {
        y: '100%'
      });

      tl.set($content, {
        autoAlpha: 0,
        y: 70
      });

      tl.to($pageTitle, 0.6, {
        y: '0%',
        ease: Quart.easeOut,
        force3D: true
      });

      tl.to($content, 0.6, {
        autoAlpha: 1,
        y: 0,
        ease: Quart.easeOut,
        force3D: true
      }, 0.1);
    },
    leave: function leave(done) {
      var tl = new TimelineMax({
        onComplete: done
      });

      var $pageTitle = this.$el.querySelector('.js-page-title');
      var $content = this.$el.querySelector('.js-content');

      tl.to($pageTitle, 0.4, {
        y: '-104%',
        ease: Quart.easeOut,
        force3D: true
      });

      tl.to($content, 0.4, {
        autoAlpha: 0,
        y: -70,
        ease: Quart.easeOut,
        force3D: true
      }, 0.1);
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "contact-view",

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    email: function email(state) {
      return state.email;
    }
  }),

  methods: {
    enter: function enter(done) {
      var tl = new TimelineMax({
        onComplete: done
      });

      var $pageTitle = this.$el.querySelector(".js-page-title");
      var $content = this.$el.querySelectorAll(".js-content");
      var $social = this.$el.querySelectorAll(".js-social");

      tl.set($pageTitle, {
        y: "100%"
      });

      tl.set($content, {
        autoAlpha: 0,
        y: 35
      });

      tl.set($social, {
        autoAlpha: 0,
        y: 25
      });

      tl.to($pageTitle, 0.6, {
        y: "0%",
        ease: Quart.easeOut,
        force3D: true
      });

      tl.staggerTo($content, 0.6, {
        autoAlpha: 1,
        y: 0,
        ease: Quart.easeOut,
        force3D: true
      }, 0.1, 0.1);

      tl.staggerTo($social, 0.8, {
        autoAlpha: 1,
        y: 0,
        ease: Quart.easeOut,
        force3D: true
      }, 0.1, 0.4);
    },
    leave: function leave(done) {
      var tl = new TimelineMax({
        onComplete: done
      });

      var $pageTitle = this.$el.querySelector(".js-page-title");
      var $content = this.$el.querySelectorAll(".js-content");
      var $social = this.$el.querySelectorAll(".js-social");

      tl.to($pageTitle, 0.4, {
        y: "-100%",
        ease: Quart.easeOut,
        force3D: true
      });

      tl.staggerTo($content, 0.4, {
        autoAlpha: 0,
        y: -35,
        ease: Quart.easeOut,
        force3D: true
      }, 0.1, 0.1);

      tl.staggerTo($social, 0.3, {
        autoAlpha: 0,
        y: -25,
        ease: Quart.easeOut,
        force3D: true
      }, -0.1, 0.3);
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseVideo__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BaseVideo__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "home-view",
  components: {
    BaseVideo: __WEBPACK_IMPORTED_MODULE_0__components_BaseVideo___default.a
  },
  props: {
    mouse: Object,
    tilt: Object,
    isDesktop: Boolean
  },

  data: function data() {
    return {
      centerX: 0,
      centerY: 0,
      $titles: null,
      loopSrc: null
    };
  },


  watch: {
    mouse: function mouse(_mouse) {
      this.updateTitle();
    }
  },

  created: function created() {
    this.loopSrc = this.isDesktop ? "/static/loop.mp4" : "/static/loop-mobile.mp4";
  },
  mounted: function mounted() {
    this.centerX = window.innerWidth / 2;
    this.centerY = window.innerHeight / 2;
    this.$titles = this.$el.querySelector("#titles");
  },


  methods: {
    updateTitle: function updateTitle() {
      var x = void 0;
      var y = void 0;

      if (this.isDesktop) {
        x = this.mouse.x;
        y = this.mouse.y;
      } else {
        x = this.tilt.x * 12.5;
        y = this.tilt.y * 12.5;
      }

      if (x === 0 && y === 0) {
        return;
      }

      var sensibility = 0.1;

      var dX = void 0;
      var dY = void 0;
      var offsetX = void 0;
      var offsetY = void 0;

      dX = x - this.centerX;
      dY = y - this.centerY;

      offsetX = dX * sensibility;
      offsetY = dY * sensibility;

      TweenMax.set(this.$titles, {
        x: offsetX,
        y: offsetY,
        force3D: true
      });
    },
    enter: function enter(done) {
      TweenMax.from(this.$el, 0.6, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-found',

  methods: {
    enter: function enter(done) {
      TweenMax.from(this.$el, 0.6, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done
      });
    },
    leave: function leave(done) {
      TweenMax.to(this.$el, 0.4, {
        autoAlpha: 0,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: done
      });
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_UDOM__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_UMath__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(10);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "project-list-view",
  props: {
    mouse: Object,
    mouseNoI: Object,
    isDesktop: Boolean,
    scrollContent: Function
  },
  data: function data() {
    return {
      $transition: null,
      $projectHovered: null,
      mI: {
        x: 0,
        y: 0
      }
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    numberOfItemToAnimate: function numberOfItemToAnimate() {
      return 2;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    projects: function projects(state) {
      return state.projects;
    }
  })),

  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_2__util_EventBus__["a" /* default */].$on("rAF", this.rAF);

    this.$transition = this.$el.querySelector(".js-project-transition");

    TweenMax.set(this.$transition, {
      scaleX: 0
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__util_EventBus__["a" /* default */].$off("rAF");
  },


  methods: {
    onProjectHover: function onProjectHover(e) {
      this.$projectHovered = e.currentTarget;

      // reset MouseInertia to center
      this.mI = {
        x: window.innerWidth / 2,
        y: this.$projectHovered.offsetHeight
      };
    },
    updateMousePos: function updateMousePos(e) {
      var $projectBody = this.$projectHovered.querySelector(".js-project-body");
      var sensibility = 0.3;

      var center = {
        x: window.innerWidth / 2,
        y: this.$projectHovered.offsetHeight
      };

      var _mouseNoI = this.mouseNoI,
          x = _mouseNoI.x,
          y = _mouseNoI.y;

      // create own MouseInertia to avoid jump

      this.mI = {
        x: __WEBPACK_IMPORTED_MODULE_3__util_UMath__["a" /* getInertia */](x, this.mI.x, this.$parent.MOUSE_INERTIA),
        y: __WEBPACK_IMPORTED_MODULE_3__util_UMath__["a" /* getInertia */](y, this.mI.y, this.$parent.MOUSE_INERTIA)
      };

      var dX = void 0;
      var dY = void 0;
      var offsetX = void 0;
      var offsetY = void 0;

      dX = this.mI.x - center.x;
      dY = this.mI.y - center.y;

      offsetX = dX * sensibility;
      offsetY = dY * sensibility;

      TweenMax.set($projectBody, {
        x: offsetX,
        y: offsetY,
        force3D: true
      });
    },
    resetMousePos: function resetMousePos(e) {
      var $element = e.currentTarget;
      var $project = __WEBPACK_IMPORTED_MODULE_1__util_UDOM__["a" /* closest */]($element, ".js-project");

      var $projectBody = $project.querySelector(".js-project-body");

      TweenMax.to($projectBody, 0.8, {
        x: 0,
        y: 0,
        ease: Quart.easeOut,
        force3D: true
      });

      this.$projectHovered = null;
    },
    enter: function enter(done) {
      var tl = new TimelineMax({
        onComplete: done
      });

      var projectItems = this.$el.querySelectorAll(".js-project");

      tl.set(projectItems, {
        y: 35,
        autoAlpha: 0
      });

      tl.staggerTo(projectItems, 0.5, {
        y: 0,
        autoAlpha: 1,
        force3D: true,
        easing: Quart.easeOut
      }, 0.15);
    },
    leave: function leave(done) {
      if (this.$route.name === "Project") {
        done();
      } else {
        TweenMax.set(this.$transition, { autoAlpha: 0 });
        TweenMax.to(this.$el, 0.35, {
          autoAlpha: 0,
          ease: Quad.easeOut,
          force3D: true,
          onComplete: done
        });
      }
    },
    viewProject: function viewProject(slug) {
      var duration = this.isDesktop ? 0.8 : 0.6;

      TweenMax.to(this.$transition, duration, {
        scaleX: 1,
        force3D: true,
        ease: Quart.easeOut,
        onComplete: this.onTransitonComplete,
        onCompleteScope: this,
        onCompleteParams: [slug]
      });
    },
    onTransitonComplete: function onTransitonComplete(slug) {
      window.scrollTo(0, 0);
      this.$parent.resetScroll();
      this.$router.push({ name: "Project", params: { slug: slug } });
    },
    rAF: function rAF() {
      if (this.$projectHovered && this.isDesktop) {
        this.updateMousePos();
      }
      if (this.isDesktop) {
        this.scrollContent();
      }
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_EventBus__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CMSContent__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CMSContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CMSContent__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "project-view",
  props: {
    isDesktop: Boolean,
    scrollContent: Function,
    initObserver: Function
  },

  components: {
    CmsContent: __WEBPACK_IMPORTED_MODULE_2__components_CMSContent___default.a
  },

  data: function data() {
    return {
      $transition: null,
      $project: null,
      project: null,
      projectKey: null,
      previousProject: null,
      nextProject: null
    };
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    projects: function projects(state) {
      return state.projects;
    }
  }),

  watch: {
    $route: function $route() {
      this.onProjectChange();
    }
  },

  beforeMount: function beforeMount() {
    var slug = this.$route.params.slug;


    this.getProject(slug);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__util_EventBus__["a" /* default */].$on("rAF", this.rAF);

    this.$project = this.$el.querySelector(".project");
    this.$transition = this.$el.querySelector(".js-project-transition");

    this.initObserver();

    TweenMax.set(this.$transition, {
      scaleX: 0
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__util_EventBus__["a" /* default */].$off("rAF");
  },


  methods: {
    enter: function enter(done) {
      TweenLite.from(this.$project, 0.6, {
        autoAlpha: 0,
        ease: Quad.easeOut,
        force3D: true,
        onComplete: done,
        onCompleteScope: this
      });
    },
    rAF: function rAF() {
      if (this.isDesktop) {
        this.scrollContent();
      }
    },
    onProjectChange: function onProjectChange() {
      var animationDuration = this.isDesktop ? 0.8 : 0.6;

      TweenMax.set(this.$transition, { transformOrigin: "100% 50%" });
      TweenMax.to(this.$transition, animationDuration, {
        scaleX: 1,
        force3D: true,
        ease: Quart.easeOut,
        onComplete: this.onProjectChanged
      });
    },
    onProjectChanged: function onProjectChanged() {
      var _this = this;

      this.project = null;
      this.previousProject = null;
      this.nextProject = null;

      var slug = this.$route.params.slug;

      this.getProject(slug);

      this.resetScroll();

      var animationDuration = this.isDesktop ? 0.9 : 0.6;

      TweenMax.set(this.$transition, { transformOrigin: "0% 50%" });
      TweenMax.to(this.$transition, animationDuration, {
        scaleX: 0,
        delay: 0.4,
        ease: Quart.easeOut,
        force3D: true,
        onComplete: function onComplete() {
          _this.$parent.setBodyHeight();
          _this.resetObserver();
          _this.initObserver();

          TweenMax.set(_this.$transition, {
            scaleX: 0
          });
        }
      });
    },
    resetObserver: function resetObserver() {
      console.log("resetObserver");

      var $sections = document.querySelectorAll(".js-observer");
      var $section;

      for (var i = 0; i < $sections.length; i++) {
        $section = $sections[i];
        $section.classList.remove("is-visible");
      }
    },
    getProject: function getProject(slug) {
      var _this2 = this;

      var project = this.projects.find(function (project, key) {
        _this2.projectKey = key;
        return project.slug === slug;
      });

      if (!project) {
        this.$router.push({ name: "NotFound" });
      } else {
        this.project = project;
      }

      if (this.projectKey > 0) {
        this.previousProject = this.projects[this.projectKey - 1];
      }

      if (this.projectKey < this.projects.length) {
        this.nextProject = this.projects[this.projectKey + 1];
      }
    },
    resetScroll: function resetScroll() {
      window.scrollTo(0, 0);
      this.$parent.resetScroll();
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchEmail;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchAboutContent;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchProjects;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Config__ = __webpack_require__(95);



function fetchEmail() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_Config__["a" /* ApiConfig */].url + 'options/v1/email');
}

function fetchAboutContent() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_Config__["a" /* ApiConfig */].url + 'wp/v2/pages/8');
}

function fetchProjects() {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__util_Config__["a" /* ApiConfig */].url + 'wp/v2/project');
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_lazyload__ = __webpack_require__(56);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive("lazyload", __WEBPACK_IMPORTED_MODULE_4__directives_lazyload__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(91);


/* harmony default export */ __webpack_exports__["a"] = ({
  // get email adress
  FETCH_EMAIL: function FETCH_EMAIL(_ref) {
    var commit = _ref.commit;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* fetchEmail */])().then(function (email) {
      commit("SET_EMAIL", email);
    });
  },

  // get about page content
  FETCH_ABOUT_CONTENT: function FETCH_ABOUT_CONTENT(_ref2) {
    var commit = _ref2.commit;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* fetchAboutContent */])().then(function (_ref3) {
      var data = _ref3.data;

      commit("SET_ABOUT_CONTENT", data);
    });
  },

  // get projects
  FETCH_PROJECTS: function FETCH_PROJECTS(_ref4) {
    var commit = _ref4.commit;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["c" /* fetchProjects */])().then(function (_ref5) {
      var data = _ref5.data;

      commit("SET_PROJECTS", data);
    });
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
  SET_EMAIL: function SET_EMAIL(state, _ref) {
    var data = _ref.data;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'email', data);
  },

  SET_ABOUT_CONTENT: function SET_ABOUT_CONTENT(state, _ref2) {
    var content = _ref2.content;

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.content, 'about', content.rendered);
  },

  SET_PROJECTS: function SET_PROJECTS(state, projects) {
    projects.forEach(function (project, key) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.projects, key, project);
    });
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApiConfig; });
var ApiConfig = {
  url: "https://api.paulthibault.fr/wp-json/"
  // url:
  //   process.env.NODE_ENV === 'production'
  //     ? 'http://api.paulthibault.fr/wp-json/'
  //     : 'http://localhost:8888/freelance/paul-thibault/PAUL_THIBAULT-API_2017/wp-json/'
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closest;
function closest(el, s) {
  var matches = (el.document || el.ownerDocument).querySelectorAll(s),
      i = void 0;
  do {
    i = matches.length;
    while (--i >= 0 && matches.item(i) !== el) {};
  } while (i < 0 && (el = el.parentElement));
  return el;
}

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d6e4022",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e9a431e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(145)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9b35c384",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1233fa2f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
  __webpack_require__(135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d2fe78e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(172),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-43e2a274",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-283b4587",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(144)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8eb5231c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(173),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e9ffd3d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c683e84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-531e6380",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('p', {
    staticClass: "percentage"
  }, [_vm._v(_vm._s(_vm.formatedPercentage) + " %")])])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "wrap-mails"
  }, [_c('a', {
    staticClass: "mail js-content",
    attrs: {
      "href": 'mailto:' + _vm.email
    }
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v(" "), _c('a', {
    staticClass: "mail js-content",
    attrs: {
      "href": "tel:+33 6 32 44 54 27"
    }
  }, [_vm._v("+33 6 32 44 54 27")])]), _vm._v(" "), _c('ul', {
    staticClass: "socials no-style"
  }, [_c('li', {
    staticClass: "social js-social"
  }, [_c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://vimeo.com/paulthibault",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "46px",
      "height": "40px",
      "viewBox": "0 0 46 40",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("vimeo-logo")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Maquette",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Contact",
      "transform": "translate(-601.000000, -867.000000)",
      "fill": "#333333"
    }
  }, [_c('g', {
    attrs: {
      "id": "Socials",
      "transform": "translate(601.000000, 867.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "vimeo-logo"
    }
  }, [_c('g', {
    attrs: {
      "id": "Capa_1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M39.2955523,0.0806417112 C32.8973976,-0.12802139 28.5676888,3.45935829 26.300541,10.8468449 C27.4681414,10.3662032 28.6027853,10.1236364 29.7093948,10.1236364 C32.0424556,10.1236364 33.0751271,11.4324064 32.7994912,14.0568984 C32.6627433,15.6462032 31.6319978,17.9587166 29.7093948,20.9935829 C27.7791948,24.0334759 26.3374565,25.5508021 25.3796861,25.5508021 C24.1362216,25.5508021 23.0043598,23.2023529 21.9709393,18.5112299 C21.6243614,17.1296257 21.0046087,13.6115508 20.1172453,7.94812834 C19.2853086,2.70256684 17.0869627,0.251657754 13.5123636,0.596149733 C12.0002184,0.735080214 9.73499659,2.11925134 6.71177617,4.73882353 C4.50615422,6.74139037 2.27142787,8.74449198 0,10.7455615 L2.16410536,13.5382888 C4.22955534,12.0878075 5.4378163,11.3659893 5.773373,11.3659893 C7.35720923,11.3659893 8.83629098,13.8493048 10.2126513,18.8152941 C11.4463786,23.3761497 12.6905921,27.9308021 13.9303115,32.4850267 C15.7767294,37.4546524 18.0529723,39.9404278 20.7304709,39.9404278 C25.0611426,39.9404278 30.363602,35.8693048 36.6168768,27.7240642 C42.6664206,19.9263102 45.7895805,13.7826738 46.0002664,9.29187166 C46.2779353,3.29026738 44.043209,0.216898396 39.2955523,0.0806417112 Z",
      "id": "Vimeo"
    }
  })])])])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "social js-social"
  }, [_c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://www.linkedin.com/in/paul-thibault-17953bba",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "42px",
      "height": "40px",
      "viewBox": "0 0 42 40",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("linkedin-logo")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Maquette",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Contact",
      "transform": "translate(-702.000000, -867.000000)",
      "fill": "#333333"
    }
  }, [_c('g', {
    attrs: {
      "id": "Socials",
      "transform": "translate(601.000000, 867.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "linkedin-logo",
      "transform": "translate(101.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Capa_1"
    }
  }, [_c('path', {
    attrs: {
      "d": "M41.7582449,24.5187379 L41.7582449,39.9572816 L32.8081009,39.9572816 L32.8081009,25.5527184 C32.8081009,21.9341748 31.5135591,19.4646602 28.2739037,19.4646602 C25.8008376,19.4646602 24.3291142,21.128932 23.6816491,22.738835 C23.4455365,23.3143689 23.3847608,24.1154369 23.3847608,24.921068 L23.3847608,39.9572816 L14.4316072,39.9572816 C14.4316072,39.9572816 14.5521877,15.5606796 14.4316072,13.0330097 L23.3838871,13.0330097 L23.3838871,16.8494175 C23.365732,16.8779612 23.3421402,16.9087379 23.3250531,16.9364078 L23.3838871,16.9364078 L23.3838871,16.8494175 C24.573285,15.0174757 26.6974248,12.4004854 31.4519096,12.4004854 C37.3423952,12.4003883 41.7582449,16.2486408 41.7582449,24.5187379 Z M5.06622731,0.0541747573 C2.00336509,0.0541747573 0,2.06320388 0,4.70514563 C0,7.28951456 1.94540488,9.35951456 4.94739432,9.35951456 L5.00719916,9.35951456 C8.12938079,9.35951456 10.0710964,7.28990291 10.0710964,4.70514563 C10.0122624,2.06320388 8.12938079,0.0541747573 5.06622731,0.0541747573 Z M0.531738823,39.9572816 L9.48149446,39.9572816 L9.48149446,13.0330097 L0.531738823,13.0330097 L0.531738823,39.9572816 Z",
      "id": "LinkedIn"
    }
  })])])])])])])])]), _vm._v(" "), _c('li', {
    staticClass: "social js-social"
  }, [_c('a', {
    staticClass: "social-link",
    attrs: {
      "href": "https://www.instagram.com/paulthibault/",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "40px",
      "height": "40px",
      "viewBox": "0 0 40 40",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("instagram-logo")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Maquette",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Contact",
      "transform": "translate(-799.000000, -867.000000)",
      "fill": "#333333"
    }
  }, [_c('g', {
    attrs: {
      "id": "Socials",
      "transform": "translate(601.000000, 867.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "instagram-logo",
      "transform": "translate(198.000000, 0.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Layer_1"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.8014118,0 L10.9774118,0 C4.92447059,0 0,4.92470588 0,10.9776471 L0,28.8016471 C0,34.8548235 4.92447059,39.7792941 10.9774118,39.7792941 L28.8014118,39.7792941 C34.8548235,39.7792941 39.7792941,34.8545882 39.7792941,28.8016471 L39.7792941,10.9776471 C39.7795294,4.92470588 34.8548235,0 28.8014118,0 Z M36.2501176,28.8016471 C36.2501176,32.9087059 32.9087059,36.2498824 28.8016471,36.2498824 L10.9774118,36.2498824 C6.87058824,36.2501176 3.52941176,32.9087059 3.52941176,28.8016471 L3.52941176,10.9776471 C3.52941176,6.87082353 6.87058824,3.52941176 10.9774118,3.52941176 L28.8014118,3.52941176 C32.9084706,3.52941176 36.2498824,6.87082353 36.2498824,10.9776471 L36.2498824,28.8016471 L36.2501176,28.8016471 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.8896471,9.64 C14.2376471,9.64 9.63952941,14.2381176 9.63952941,19.8901176 C9.63952941,25.5418824 14.2376471,30.1397647 19.8896471,30.1397647 C25.5416471,30.1397647 30.1397647,25.5418824 30.1397647,19.8901176 C30.1397647,14.2381176 25.5416471,9.64 19.8896471,9.64 Z M19.8896471,26.6101176 C16.184,26.6101176 13.1689412,23.5955294 13.1689412,19.8898824 C13.1689412,16.184 16.1837647,13.1691765 19.8896471,13.1691765 C23.5955294,13.1691765 26.6103529,16.184 26.6103529,19.8898824 C26.6103529,23.5955294 23.5952941,26.6101176 19.8896471,26.6101176 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M30.5696471,6.64729412 C29.8896471,6.64729412 29.2216471,6.92258824 28.7414118,7.40494118 C28.2588235,7.88494118 27.9814118,8.55317647 27.9814118,9.23552941 C27.9814118,9.91576471 28.2590588,10.5837647 28.7414118,11.0661176 C29.2214118,11.5461176 29.8896471,11.8237647 30.5696471,11.8237647 C31.252,11.8237647 31.9178824,11.5461176 32.4002353,11.0661176 C32.8825882,10.5837647 33.1578824,9.91552941 33.1578824,9.23552941 C33.1578824,8.55317647 32.8825882,7.88494118 32.4002353,7.40494118 C31.9202353,6.92258824 31.252,6.64729412 30.5696471,6.64729412 Z",
      "id": "Shape"
    }
  })])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask mask--page-title"
  }, [_c('h1', {
    staticClass: "page-title js-page-title"
  }, [_vm._v("contact")])])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shapes js-shapes",
    class: {
      'is-visible': _vm.isVisible
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "layer js-first-layer"
  }, [_c('div', {
    staticClass: "shape shape--stick is-45 is-grey is-first"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layer is-second js-second-layer"
  })])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseImage",
    class: ("BaseImage--" + _vm.size),
    style: ([
      _vm.size == 'aspect-ratio' && {
        paddingBottom: (((_vm.height / _vm.width) * 100) + "%"),
      } ])
  }, [_c('img', {
    directives: [{
      name: "lazyload",
      rawName: "v-lazyload"
    }],
    staticClass: "BaseImage-image u-posAbsoluteCenter",
    attrs: {
      "alt": _vm.alt,
      "data-src": _vm.src,
      "data-srcset": _vm.srcset,
      "decoding": "async"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    class: {
      'is-open': _vm.isOpen
    }
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('h1', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Paul Thibault")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navigation",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('nav', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "nav-list no-style"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("à propos")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/project"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("réalisations")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("contact")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation__burger"
  }, [_c('div', {
    staticClass: "navigation__burger-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__burger-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation__cross"
  }, [_c('div', {
    staticClass: "navigation__cross-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__cross-bar"
  })])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_vm._m(0), _vm._v(" "), _c('cms-content', {
    staticClass: "content js-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mask mask--page-title"
  }, [_c('h1', {
    staticClass: "page-title js-page-title"
  }, [_vm._v("à propos")])])
}]}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-found"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Erreur 404")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("La page que vous cherchez n'est pas disponible ou n'existe plus")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v("retourner à l'accueil")])])], 1), _vm._v(" "), _c('video', {
    staticClass: "video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "src": "/static/404.mp4"
    },
    domProps: {
      "muted": true
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "project-wrapper"
  }, [_c('article', {
    staticClass: "project"
  }, [_c('h1', {
    staticClass: "project__title"
  }, [_vm._v(_vm._s(_vm.project.title.rendered))]), _vm._v(" "), _c('div', {
    staticClass: "project-header"
  }, [_c('div', {
    staticClass: "project-header__informations"
  }, [_c('h2', {
    staticClass: "project-header__title"
  }, [_vm._v("Infos")]), _vm._v(" "), _c('ul', {
    staticClass: "project-header__list no-style"
  }, _vm._l((_vm.project.CFS.informations), function(information, key) {
    return _c('li', {
      key: key,
      staticClass: "project-header__item"
    }, [_vm._v("\n            " + _vm._s(information.information) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('cms-content', {
    staticClass: "project-header__description",
    domProps: {
      "innerHTML": _vm._s(_vm.project.content.rendered)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project__video-wrapper"
  }, [_c('div', {
    staticClass: "project__video-inner"
  }, [_c('iframe', {
    staticClass: "project__video",
    attrs: {
      "src": _vm.project.CFS.videoLink,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _vm._l((_vm.project.CFS.makingOf), function(makingOf, key) {
    return _c('div', {
      key: key,
      staticClass: "project-picture js-observer",
      class: {
        'project-picture--left': key % 2 === 1
      }
    }, [_c('div', {
      staticClass: "project-picture__wrapper"
    }, [_c('img', {
      staticClass: "project-picture__picture",
      attrs: {
        "src": makingOf.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "project-picture__mask"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "project-navigation",
    class: {
      'has-only-previous': !_vm.nextProject,
      'has-only-next': !_vm.previousProject,
    }
  }, [(_vm.previousProject) ? _c('div', {
    staticClass: "project-navigation__item"
  }, [_c('p', {
    staticClass: "project-navigation__label"
  }, [_vm._v("Précédent")]), _vm._v(" "), _c('router-link', {
    staticClass: "project-navigation__title",
    attrs: {
      "to": {
        name: 'Project',
        params: {
          slug: _vm.previousProject.slug
        }
      },
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v(_vm._s(_vm.previousProject.title.rendered))])])], 1) : _vm._e(), _vm._v(" "), (_vm.nextProject) ? _c('div', {
    staticClass: "project-navigation__item"
  }, [_c('p', {
    staticClass: "project-navigation__label"
  }, [_vm._v("Suivant")]), _vm._v(" "), _c('router-link', {
    staticClass: "project-navigation__title",
    attrs: {
      "to": {
        name: 'Project',
        params: {
          slug: _vm.nextProject.slug
        }
      },
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v(_vm._s(_vm.nextProject.title.rendered))])])], 1) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "project__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "projects__transition js-project-transition"
  })])
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "projects"
  }, [_vm._l((_vm.projects), function(project, key) {
    return _c('article', {
      key: key,
      staticClass: "project js-project",
      on: {
        "mouseenter": _vm.onProjectHover,
        "mouseleave": _vm.resetMousePos,
        "click": function($event) {
          return _vm.viewProject(project.slug)
        }
      }
    }, [_c('div', {
      staticClass: "project__body js-project-body"
    }, [_c('h1', {
      staticClass: "project__title"
    }, [_vm._v(_vm._s(project.title.rendered))]), _vm._v(" "), _c('h2', {
      staticClass: "projet__type"
    }, [_vm._v(_vm._s(project.category))])]), _vm._v(" "), _c('div', {
      staticClass: "project__thumbnail-wrapper"
    }, [_c('img', {
      staticClass: "project__thumbnail",
      class: project.CFS.thumbnailAlignement &&
        ("project__thumbnail--" + (project.CFS.thumbnailAlignement[0])),
      attrs: {
        "src": project.better_featured_image.source_url,
        "alt": project.title.rendered
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "projects__transition js-project-transition"
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cms-content"
  })
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "home-wrapBackground u-posFullScreen"
  }, [_c('base-video', {
    attrs: {
      "placeholder-src": "/static/loop-placeholder.jpg",
      "src": _vm.loopSrc
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner",
    attrs: {
      "id": "titles"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n      Paul"), _c('br'), _vm._v("\n      Thibault\n    ")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("filmmaker")])])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Video"
  }, [_c('video', {
    directives: [{
      name: "lazyload",
      rawName: "v-lazyload",
      value: ({
        callback: _vm.onLoaded
      }),
      expression: "{ callback: onLoaded }"
    }],
    staticClass: "Video-video",
    attrs: {
      "muted": "",
      "loop": "",
      "playsinline": "",
      "autoplay": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "data-src": _vm.src,
      "type": "video/mp4"
    }
  })]), _vm._v(" "), (!_vm.isLoaded) ? _c('base-image', {
    staticClass: "Video-placeholder u-posFit",
    attrs: {
      "size": "cover",
      "src": _vm.placeholderSrc
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    class: _vm.$route.name.toLowerCase(),
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoaderShow) ? _c('app-header', {
    style: (_vm.loadingStyle)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "main",
    staticClass: "main-wrapper",
    style: (_vm.loadingStyle),
    attrs: {
      "id": "mainWrapper"
    }
  }, [_c('main', {
    staticClass: "main"
  }, [_c('transition', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    attrs: {
      "mode": "out-in",
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "page",
    attrs: {
      "mouse": _vm.mI,
      "mouseNoI": _vm.m,
      "scrollContent": _vm.scrollContent,
      "initObserver": _vm.initObserver,
      "is-desktop": _vm.isDesktop
    }
  })], 1)], 1)]), _vm._v(" "), _c('shapes', {
    ref: "$shapes",
    style: (_vm.loadingStyle),
    attrs: {
      "mouse": _vm.mI,
      "number": _vm.numberOfShapes,
      "is-dekstop": _vm.isDesktop,
      "is-visible": _vm.isShapesVisible
    }
  }), _vm._v(" "), _c('loader', {
    ref: "loader",
    attrs: {
      "isVisible": _vm.isLoading,
      "percentage": _vm.loaderProgress
    },
    on: {
      "shown": _vm.onLoaderShown,
      "hidden": _vm.onLoaderHidden
    }
  })], 1)
},staticRenderFns: []}

/***/ })
],[92]);


// WEBPACK FOOTER //
// static/js/app.02ff3eafd50f89f05025.js